import { render, staticRenderFns } from "./priceChange.vue?vue&type=template&id=5e2ecb02&scoped=true&"
import script from "./priceChange.vue?vue&type=script&lang=js&"
export * from "./priceChange.vue?vue&type=script&lang=js&"
import style0 from "./priceChange.vue?vue&type=style&index=0&id=5e2ecb02&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ecb02",
  null
  
)

export default component.exports